/**
 * Shared MUI `sx` for booking detail top toolbar so actions read as one control family.
 */
export const bookingDetailToolbarButtonSx = {
  minHeight: 36,
  height: 36,
  px: 1.75,
  borderRadius: 2,
  fontWeight: 600,
  fontSize: '0.8125rem',
  lineHeight: 1.2,
  textTransform: 'none',
  boxShadow: 'none',
} as const;

/** Outlined “back” control — slightly lighter weight than primary actions. */
export const bookingDetailToolbarBackButtonSx = {
  ...bookingDetailToolbarButtonSx,
  fontWeight: 500,
} as const;

/** Square icon danger control aligned to the same row height as text buttons. */
export const bookingDetailToolbarIconDangerSx = {
  minHeight: 36,
  height: 36,
  minWidth: 40,
  width: 40,
  p: 0,
  borderRadius: 2,
  boxShadow: 'none',
} as const;
